<template>
  <div class="app-layout">
    <div class="sidebar-overlay" v-if="sidebarOpen" @click="sidebarOpen = false"></div>

    <SidebarNav
      :isOpen="sidebarOpen"
      :adminName="authStore.adminName"
      :counters="counters"
      :isRoot="authStore.isRoot"
      @logout="handleLogout"
    />

    <main class="main-content">
      <header class="mobile-header">
        <button class="hamburger" @click="sidebarOpen = !sidebarOpen" aria-label="Menu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3 18h18v-2H3v2Zm0-5h18v-2H3v2Zm0-7v2h18V6H3Z"/></svg>
        </button>
        <span class="mobile-title">Acamp Check-in</span>
      </header>

      <div class="content-area">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
import SidebarNav from '../components/ui/SidebarNav.vue'
import { useAuthStore } from '../stores/auth'
import { useAcampantesStore } from '../stores/acampantes'

export default {
  name: 'AppLayout',
  components: { SidebarNav },
  data() {
    return { sidebarOpen: false }
  },
  computed: {
    authStore() { return useAuthStore() },
    acampantesStore() { return useAcampantesStore() },
    counters() {
      return {
        total: this.acampantesStore.totalCount,
        pending: this.acampantesStore.pendingCount,
        confirmed: this.acampantesStore.confirmedCount
      }
    }
  },
  mounted() {
    this.acampantesStore.fetchAll().catch(() => {
      this.$toast.open({ message: 'Não foi possível carregar acampantes', type: 'error', position: 'top-right' })
    })
  },
  watch: {
    '$route'() { this.sidebarOpen = false }
  },
  methods: {
    handleLogout() {
      this.authStore.logout()
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.app-layout { display: flex; min-height: 100vh; }
.main-content { flex: 1; margin-left: 250px; display: flex; flex-direction: column; }
.content-area { flex: 1; padding: var(--spacing-lg); }

.mobile-header {
  display: none;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-base);
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-card);
  position: sticky; top: 0; z-index: 40;
}
.hamburger {
  background: none; border: none; cursor: pointer;
  color: var(--color-text-primary); padding: var(--spacing-sm);
  display: flex;
}
.mobile-title {
  font-size: var(--text-lg); font-weight: 700; color: var(--color-text-primary);
}
.sidebar-overlay {
  display: none; position: fixed; inset: 0;
  background: rgba(0, 0, 0, 0.5); z-index: 45;
}

@media (max-width: 768px) {
  .main-content { margin-left: 0; }
  .mobile-header { display: flex; }
  .sidebar-overlay { display: block; }
}
</style>
